<template>
  <div>
    {{ rowData.product_type_id | CategoryToString }}
  </div>
</template>

<script>
export default {
  props: ['rowData']
}
</script>
